// Paths split from the seedling SVG so each can be animated independently.
// Leaf: upper-right sprout; vine: lower-left stem.
const LEAF_PATH =
  'M32 2C32 8.75 27.1875 14.375 20.875 15.6875C20.375 12.0625 18.75 8.8125 16.3125 6.3125C18.8125 2.5 23.125 0 28 0H30C31.125 0 32 0.875 32 2Z'
const VINE_PATH =
  'M0 6C0 4.875 0.875 4 2 4H4C11.75 4 18 10.25 18 18V30C18 31.125 17.125 32 16 32C14.875 32 14 31.125 14 30V20C6.25 20 0 13.75 0 6Z'

interface LeafProps {
  /** Side length in px (renders as a square). Defaults to 24. */
  size?: number
}

/**
 * Static seedling icon (vine + leaf paths) used in ChatPanelHeader.
 * For the animated version with per-path refs used in ChatTrigger, see the
 * inline SVG in that component.
 */
export const Leaf = ({ size = 24 }: LeafProps) => (
  <svg
    viewBox="0 0 32 32"
    width={size}
    height={size}
    aria-hidden="true"
    className="shrink-0"
  >
    <path d={VINE_PATH} fill="var(--adviser-icon-leaf)" />
    <path d={LEAF_PATH} fill="var(--adviser-icon-leaf)" />
  </svg>
)
